import React from 'react'
import {Box, StyleProps, Text} from '@miro-site/core'
import {useTheme} from 'styled-components'
import {useTranslation} from 'next-i18next'

type CardTagsProps = {
  descriptionStyles?: StyleProps
  headingStyles?: StyleProps
  tags: string[] | null
}

/**
 * Used to output flip card tags that a user can set
 * in our contentful general templates collection
 */
export const CardTags: React.FC<CardTagsProps> = ({descriptionStyles, headingStyles, tags}) => {
  if (!Array.isArray(tags) || !tags?.length) {
    return null
  }

  const theme = useTheme()
  const {t} = useTranslation('common')

  return (
    <Box
      $styles={{
        backgroundColor: theme.templates.colors.secondary4,
        padding: [16, 20],
        marginBottom: 24,
        borderRadius: 8,
      }}
    >
      <Text
        as="h4"
        $color="primaryIndigo"
        $mb={12}
        $styles={{
          fontWeight: 700,
          fontSize: 14,
          lineHeight: 20,
          ...headingStyles,
        }}
      >
        {t('works-best-for')}
      </Text>
      <Text
        $variant={['p1', 'p2', 'p2', 'p2']}
        $styles={{
          color: theme.templates.colors.secondary60,
          fontSize: 14,
          lineHeight: 20,
          ...descriptionStyles,
        }}
      >
        {tags.join(', ')}
      </Text>
    </Box>
  )
}
